import { QV_TYPE } from '../configs/constants';
import { assetMapping } from '../../../utils/helpers';

export const isFinanceQV = permissions => permissions.allowAppQuickView === 'finance';
export const isDefaultQV = permissions => permissions.allowAppQuickView === 'default';

export const getQVTypeByKind = (kind) => {
  if (assetMapping.apps.includes(kind)) {
    return QV_TYPE.app;
  }

  if (assetMapping.publishers.includes(kind)) {
    return QV_TYPE.publisher;
  }

  if (assetMapping.companies.includes(kind)) {
    return QV_TYPE.company;
  }

  return null;
};
